<template>
  <div
    v-if="dsComponentDetails.version === VersionOptions.LEGACY"
    data-sb-regression="sb-filter-chips"
  >
    <!--
      @slot slot to show individual filter chip
    -->
    <slot
      v-for="filter in filters"
      :filter="filter"
    />
  </div>
  <SbFilterChipsNext
    v-else
    :filters="filters"
    :applied-filters="appliedFilters"
  />
</template>

<script>
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import SbFilterChipsNext from '@src/components/Filter/next/components/SbFilterChipsNext.vue';
/**
 * This is a wrapper component to display all of the active filters.
 * You should use SbChip component in the scoped slot
 */
export default {
  name: 'SbFilterChips',
  components: {
    SbFilterChipsNext,
  },
  mixins: [versionedComponentsMixin],
  props: {
    /**
     * This is a list of filters to be displayed.
     */
    filters: {
      type: Array,
      default: () => ([]),
    },
    /**
     * This is a list of filters to be displayed.
     */
    appliedFilters: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>

<style scoped lang='scss'>

</style>
